import { render, staticRenderFns } from "./CalliaExcelToPdf.vue?vue&type=template&id=64048a56&scoped=true"
import script from "./CalliaExcelToPdf.vue?vue&type=script&lang=js"
export * from "./CalliaExcelToPdf.vue?vue&type=script&lang=js"
import style0 from "./CalliaExcelToPdf.vue?vue&type=style&index=0&id=64048a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64048a56",
  null
  
)

export default component.exports